<template>
  <div class="check-item">
    <div class="row">
      <div class="col-sm-7">{{ i18n.popUpBlocker }}</div>
      <div class="col-sm-3"></div>
      <div class="col-sm-2">
        <checker-status :result="result.value"></checker-status>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="alert alert-danger" v-show="result.value === 'failed'">{{ i18n.results.popUpBlocker }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import CheckerStatus from './CheckerStatus'

const checkerName = 'popup-blocker'

export default {
  name: checkerName,
  data () {
    return {
      status: 'in-progress',
      result: {
        value: '',
        text: ''
      },
      i18n: window.SYSTEM_CHECK.i18n
    }
  },
  components: {
    CheckerStatus
  },
  created () {
    this.$emit('initialized', {name: checkerName})
  },
  mounted () {
    var options = 'directotries=no,location=no,menubar=no,resizable=no,scrollbars=no,' +
                  'status=no,titlebar=no,toolbar=no,width=1px,height=1px,top=300000000,left=30000000'
    var isiPad = window.navigator.userAgent.match(/iPad/i) != null
    var vm = this
    var popUp = null

    setTimeout(function () {
      popUp = window.open('about:blank', '_blank', options)
      if (isiPad) {
        if (popUp) {
          vm.result.value = 'passed'
          vm.status = 'completed'
          this.$emit('completed', {name: checkerName, result: this.result.value})
          if (window.focus) {
            popUp.focus()
          }
          popUp.close()
        }
      }
    }, 2000)

    // Check again since some browser, like Chrome needs some delay before creating the pop up
    setTimeout(function () {
      if (vm.status === 'completed') {
        return
      }

      var popUpBlockerEnabled = true
      if (popUp) {
        var isChrome = window.navigator.userAgent.indexOf('Chrome')
        popUpBlockerEnabled = isChrome && popUp.screenX === 0

        // make sure not to close parent window in iPad Safari
        if (!isiPad) {
          popUp.close()
        }

        if (!isChrome && !isiPad) {
          popUpBlockerEnabled = false
        }
      }

      vm.result.value = popUpBlockerEnabled ? 'failed' : 'passed'
      vm.$emit('completed', {name: checkerName, result: vm.result.value})
    }, 5000)
  }
}
</script>
